import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { customerActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { Line, ValidationInput, EditSaveButtons } from 'components';
import {
  createInputsWrapper,
  ErrorText,
  FindErrorItem,
  FindSuccess,
  PermissionsList,
  RolePermission,
  useGlobalStyles,
  useGlobalText,
} from 'utils';

const ACTION_TYPE = 'EDIT_PORTAL';

export const PortalInfo = ({ info }) => {
  const globalStyle = useGlobalText();
  const globalWrapper = useGlobalStyles();
  const globalScreens = createInputsWrapper();
  const dispatch = useDispatch();
  const [disables, setDisabled] = useState(!!info);
  const [error, setError] = useState('');
  const [inputs, setInputs] = useState(info?.portalInfo ? { ...info.portalInfo } : {});
  const success = FindSuccess(ACTION_TYPE);
  const backError = FindErrorItem(ACTION_TYPE);
  const errorText = Array.isArray(backError?.error) ? backError?.error[0] : backError?.error;

  useEffect(() => {
    return () => {
      removeError();
    };
  }, []);

  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
      setDisabled(true);
    }
  }, [success]);

  const removeError = () => {
    errorText && dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
  };

  const handleChange = e => {
    setInputs(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
    error === e.target.name && setError('');
    removeError();
  };

  const handleCreate = () => {
    const data = {
      'name': inputs?.name,
      'website': inputs?.website,
      'username': inputs?.username,
      'password': inputs?.password,
      'notes': inputs?.notes,
    };

    dispatch(customerActions.editCustomerPortal(info.id, data));
  };

  const handleChancel = () => {
    setDisabled(true);
    setInputs({ ...info?.portalInfo });
    setError('');
    removeError();
  };

  return (
    <div className={globalScreens.createInputsWrapper}>
      <div className={globalWrapper.spaceBetween}>
        <div className={globalWrapper.centerItem}>
          {!info && <p className={globalStyle.title}>Customer Information</p>}
        </div>
        {info && RolePermission([PermissionsList.CREATE_UPDATE_CUSTOMER?.code]) &&
          <EditSaveButtons
            margin={true}
            type={ACTION_TYPE}
            handleChancel={handleChancel}
            handleSetEdit={() => setDisabled(false)}
            handleSaveInfo={handleCreate}
          />}
      </div>

      <div className={globalWrapper.flexAble}>
        {info && <Line height={'auto'} />}
        <div className={globalWrapper.fullWidth} style={{ paddingBottom: '24px' }}>
          <div className={globalScreens.basicInfo}>
            <div className={globalScreens.basicInfoInputs}>
              <ValidationInput
                className={info && globalWrapper.inputTextFieldBlue}
                style={globalWrapper.simpleInput}
                variant={'outlined'}
                name={'name'}
                type={'text'}
                label={'Portal Name'}
                typeError={error === 'name' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.name}
                disabled={disables}
              />
              <ValidationInput
                className={info && globalWrapper.inputTextFieldBlue}
                style={globalWrapper.simpleInput}
                variant={'outlined'}
                name={'website'}
                type={'text'}
                label={'Website'}
                typeError={error === 'website' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.website}
                disabled={disables}
              />
              <ValidationInput
                className={info && globalWrapper.inputTextFieldBlue}
                style={globalWrapper.simpleInput}
                variant={'outlined'}
                name={'username'}
                type={'text'}
                label={'Username'}
                typeError={error === 'username' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.username}
                disabled={disables}
              />
              <ValidationInput
                className={info && globalWrapper.inputTextFieldBlue}
                style={globalWrapper.simpleInput}
                variant={'outlined'}
                name={'password'}
                type={'text'}
                label={'Password'}
                typeError={error === 'password' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.password}
                disabled={disables}
              />
            </div>
            <div className={globalScreens.basicInfoInputs}>
              <ValidationInput
                className={info && globalWrapper.inputDescFieldBlue}
                style={globalWrapper.simpleInput}
                variant={'outlined'}
                name={'notes'}
                type={'text'}
                label={'Notes'}
                typeError={error === 'notes' ? ErrorText.field : ''}
                onChange={handleChange}
                value={inputs.notes}
                disabled={disables}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};